import { HStack, StackProps, Text, VStack } from "@chakra-ui/react";
import { NotificationInterface } from "../../constants/Notification";
import { useDarkWhiteColor } from "../../themes/colors";
import { CardNotification } from "../card/CardNotification";
import { Empty } from "../card/Empty";

interface Props extends StackProps {
  data: NotificationInterface[] | undefined;
}

export const ListDashboardNotification = ({ data, ...rest }: Props) => {
  const bgBnw = useDarkWhiteColor();

  return (
    <VStack
      w={"100%"}
      minWidth="100px"
      height={"100%"}
      minH={"390px"}
      maxH={"390px"}
      bg={bgBnw}
      gap={0}
      borderRadius={"md"}
      align={"stretch"}
      overflowY={"auto"}
      {...rest}
    >
      <HStack w={"100#"} p={4}>
        <Text textStyle={"h-reg-title"}>Notifikasi</Text>
      </HStack>

      {data && data.length < 1 ? (
        <Empty my={"auto"} title="Tidak ada notifikasi terbaru" />
      ) : (
        <VStack w={"100%"} gap={0} overflowY={"auto"}>
          {data?.map((item) => (
            <CardNotification key={item.id} data={item} />
          ))}
        </VStack>
      )}
    </VStack>
  );
};
